import { useEffect } from 'react';
import { Form, Modal, Input, Select, DatePicker, App } from 'antd';
import {
    usePayableInvoicePaymentSearchMutation
} from '../../features/api/apiSlice';
function MakePaymentThroughSearchModal ({ open, setOpen, data }) {
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [makePayment, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = usePayableInvoicePaymentSearchMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Success',
                description: '付款成功, 请前往后台任务管理获取回执文件',
            });
            setOpen(false);
            form.resetFields();
        }
        if (isError) {
            notification.error({
                message: 'Error',
                description: error.data?.error || '付款失败',
            })
        }
    }, [isSuccess, isError, error, notification, setOpen, form]);
    const okButtonHandler = () => {
        form.validateFields()
            .then((values) => {
                const formData = new FormData();
                formData.append('customer_reference', values.customer_reference);
                formData.append('payment_method_indicator', values.payment_method_indicator);
                formData.append('eft_settlement_date', values.eft_settlement_date.format('YYYY-MM-DD'));
                const request = {
                    formData: formData,
                    ...data
                }
                makePayment(request);
            })
            .catch((errorInfo) => {
                console.log('Validation failed:', errorInfo);
            });
    }
    return (
        <Modal
            title="付款确认"
            open={open}
            onOk={okButtonHandler}
            onCancel={() => setOpen(false)}
            width={600}
            confirmLoading={isLoading}
        >
            <Form
                form={form}
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 12 }}
            >
                <Form.Item
                    label="Customer Reference"
                    rules={[
                        {
                            required: true,
                            message: '请输入Customer Reference',
                        },
                    ]}
                    name="customer_reference"
                >
                    <Input placeholder="请输入" />
                </Form.Item>
                <Form.Item
                    label="Payment Method Indicator"
                    rules={[
                        {
                            required: true,
                            message: '请输入Payment Method Indicator',
                        },
                    ]}
                    name="payment_method_indicator"
                >
                    <Select
                        placeholder="请选择"
                        options={[
                            { label: 'E', value: 'E', key: 'E' },
                        ]}
                        style={{
                            textAlign: 'left',
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label="EFT Settlement Date"
                    rules={[
                        {
                            required: true,
                            message: '请输入EFT Settlement Date',
                        },
                    ]}
                    name="eft_settlement_date"
                >
                    <DatePicker style={{ width: '100%' }} />
                </Form.Item>
            </Form>
        </Modal>
    )

}

export default MakePaymentThroughSearchModal;